// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum TemplateGroup {
	Generic = 1,
	Email = 2,
	Pdf = 3,
}
